import i18n from './i18n';

export * from './languages';
export * from './translateEx';
export * from './updateLocale';
export * from './useDirection';

export default i18n;